import { RangeFilters } from 'technical/range-filters/types';

const INDICATOR_DISPLAY_TYPES_MAP = {
  bar: 'bar',
  table: 'table',
} as const;

const INDICATOR_DISPLAY_TYPES = Object.values(INDICATOR_DISPLAY_TYPES_MAP);
type IndicatorDisplayTypes = (typeof INDICATOR_DISPLAY_TYPES)[number];

const INDICATOR_GROUP_BY_TYPES_MAP = {
  report: 'report',
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

const INDICATOR_GROUP_BY_TYPES = Object.values(INDICATOR_GROUP_BY_TYPES_MAP);
export type IndicatorGroupByTypes = (typeof INDICATOR_GROUP_BY_TYPES)[number];

type IndicatorAnalyzeRangeFilters = RangeFilters<{
  displayType: IndicatorDisplayTypes;
  groupByType: IndicatorGroupByTypes;
}>;

type IndicatorAnalyzeFilters = {
  filters: IndicatorAnalyzeRangeFilters;
};

export {
  INDICATOR_DISPLAY_TYPES_MAP,
  INDICATOR_DISPLAY_TYPES,
  INDICATOR_GROUP_BY_TYPES,
  INDICATOR_GROUP_BY_TYPES_MAP,
  type IndicatorAnalyzeRangeFilters,
  type IndicatorAnalyzeFilters,
};
